var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: _vm.visible, title: "上传合同", width: "660px" },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.resetDialogData,
      },
    },
    [
      _c("ContractContent", {
        ref: "contractContentRef",
        attrs: {
          disabled: _vm.disabledContract,
          shopId: _vm.shopId,
          shopName: _vm.shopName,
        },
      }),
      _c("div", { staticClass: "audit-section upload-container" }, [
        _c("span", { staticClass: "upload-title" }, [
          _c(
            "span",
            { staticStyle: { color: "#f56c6c", "margin-right": "4px" } },
            [_vm._v("*")]
          ),
          _vm._v("合同附件"),
        ]),
        _c(
          "div",
          [
            _c("ossFileUpload", {
              ref: "refPicFileUpload",
              staticStyle: { "margin-bottom": "10px" },
              attrs: {
                limit: _vm.maxFileCount,
                accept: _vm.picFileExt,
                maxFileLength: 10,
                ossUpload: true,
                ossPathDir: "shop/pic/",
                disabled: _vm.isDisabled,
                onPreview: _vm.handlePreview,
              },
              model: {
                value: _vm.picFileList,
                callback: function ($$v) {
                  _vm.picFileList = $$v
                },
                expression: "picFileList",
              },
            }),
            !_vm.isDisabled
              ? _c("div", { staticClass: "small-tip warning" }, [
                  _c("span", [
                    _vm._v(
                      "最多支持" +
                        _vm._s(_vm.maxFileCount) +
                        "张，单张不超过10M； 支持" +
                        _vm._s(_vm.picFileExt)
                    ),
                  ]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.form.auditResult && _vm.form.auditResult != 0,
              expression: "form.auditResult && form.auditResult != 0",
            },
          ],
          staticClass: "audit-section",
        },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: { model: _vm.form, "label-width": "80px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "审核结果", prop: "auditResult" } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.checkStatusMap[_vm.form.auditResult])),
                  ]),
                ]
              ),
              _vm.form.auditResult === 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "驳回理由", prop: "rejectReason" } },
                    [_c("div", [_vm._v(_vm._s(_vm.form.rejectReason))])]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.form.auditResult == null || _vm.form.auditResult == 2,
                  expression:
                    "form.auditResult == null || form.auditResult == 2",
                },
              ],
              attrs: { type: "primary", loading: _vm.uploading },
              on: { click: _vm.submitUpload },
            },
            [_vm._v(" 保存 ")]
          ),
        ],
        1
      ),
      _c("FileViewer", { ref: "fileViewerRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }